import http from "@/services/http-common";
import authHeader from "@/services/auth-header";

class wsAltarChallengeVotesCount {
	countVoteCommunity(uuid) {
		return http.get(
			`/altar-challenge-community-votes/?filters[altar_challenge][uuid][$eq]=${uuid}`,
			{
				headers: authHeader(),
			}
		);
	}

	countVoteRme(uuid) {
		return http.get(
			`/altar-challenge-rme-votes/?filters[altar_challenge][uuid][$eq]=${uuid}`,
			{
				headers: authHeader(),
			}
		);
	}
}

export default new wsAltarChallengeVotesCount();
